import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9adf6dfe")

_pushScopeId("data-v-9adf6dfe")
const _hoisted_1 = { class: "std-page-layout-main" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_PageHeader = _resolveComponent("PageHeader")
  const _component_PageFooter = _resolveComponent("PageFooter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader, { showAppMenu: _ctx.showAccountControl }, null, 8, ["showAppMenu"]),
    _renderSlot(_ctx.$slots, "body-content", {}, undefined, true),
    _createVNode(_component_PageFooter, { class: "footer" })
  ]))
})